import styled from 'styled-components';
import { FlexColumn } from '../../../styled/common';

export const StyledLayout = styled(FlexColumn)<{ $isWebViewScroll?: boolean }>`
  min-height: 100vh;
  background-color: ${({ theme: { colors } }) => colors.background.primary};
  ${({ theme, $isWebViewScroll }) =>
    $isWebViewScroll &&
    `border-bottom: 0.5px solid ${theme.colors.border.primary}`};
  padding-bottom: ${({ theme }) => {
    const insets = theme.webview?.insets;
    if (theme.isWebView && insets) {
      return `${(insets.bottom || 0) + theme.mobile.tabBar.height}px`;
    }
    return 0;
  }};

  @media screen and (orientation: landscape) {
    min-height: 320px;
  }
`;
